import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Team from "@/components/site/Team";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import TellAFriend from "@/components/site/TellAFriend";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative font-body text-gray-900 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Team />
        <Services />
        <WhyUs />
        <TellAFriend />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
